module.exports = __webpack_public_path__ + "static/media/background-5.ac16efcf.jpg";